import { useEffect, useState } from 'react'
import { Link, Outlet, useNavigate } from 'react-router-dom'
import { adminLogout, fetchAdminMe } from '../../services/assessmentsApi'

export default function AdminLayout() {
  const navigate = useNavigate()
  const [email, setEmail] = useState<string | null>(null)
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    fetchAdminMe()
      .then((admin) => {
        if (!admin) {
          navigate('/')
          return
        }
        setEmail(admin.email)
      })
      .finally(() => setChecking(false))
  }, [navigate])

  const handleLogout = async () => {
    await adminLogout()
    navigate('/')
  }

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-assess-bg">
        <div className="w-10 h-10 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-assess-bg text-white">
      <header className="bg-assess-card border-b border-assess-border px-6 py-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold">ReallyAssess Admin</h1>
            <p className="text-xs text-gray-400">{email}</p>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/admin" className="text-sm text-gray-300 hover:text-white">
              Assessments
            </Link>
            <button
              onClick={handleLogout}
              className="text-sm px-3 py-1 rounded border border-assess-border hover:bg-assess-card"
            >
              Log out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto p-6">
        <Outlet />
      </main>
    </div>
  )
}
